import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Devopsworks() {
  return (
    <section className="devops_works p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={7}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>
              Tekrevol’s Devops Enablement: <span>How It Works?</span>
            </h2>
          </Col>
        </Row>
        <Row className="mt-3 desk_hidden">
          <Col
            xs={12}
            md={6}
            lg={3}
            xl={3}
            xxl={3}
            className="my-xxl-auto mt-xl-auto"
          >
            <div className="devops_works_box">
              <h5>Logging & Monitoring</h5>
              <p>
                Gather, classify, and analyze big data from applications, and
                infrastructure to track performance, and give feedback to make
                key adjustment to services.
              </p>
            </div>

            <div className="devops_works_box marg_top">
              <h5>Smooth Communication & Collaboration</h5>
              <p>
                Our DevOps enablement is directed towards enhancing
                communication between developers, and operations, aligning them
                for greater efficiency, and performance.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="text-center">
            <div className="devops_works_box">
              <h5>Continuous Delivery</h5>
              <p>
                Utilizing automated testing to ensure that all code is swiftly,
                and safely delivered, and deployed to the production setup.
              </p>
            </div>
            <div className="devops_works_img">
              <StaticImage
                src="../../images/services-usa/devops-enablement/devops_works.webp"
                alt="tekrevol_web"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={796}
                height={776}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={3}
            xl={3}
            xxl={3}
            className="my-xxl-auto mt-xl-auto m-md-auto"
          >
            <div className="devops_works_box devops_fourth">
              <h5>Continuous Integration</h5>
              <p>
                Leveraging test automation to ensure that even the smallest
                update runs smoothly while maintaining the software functional
                at all times.
              </p>
            </div>

            <div className="devops_works_box marg_top">
              <h5>IaC & Seamless Development</h5>
              <p>
                Our framework fosters embracing a modern-service architecture by
                leveraging serverless components and connecting with the
                infrastructure.
              </p>
            </div>
          </Col>
        </Row>
        <div className="mobile_view_devops">
          <Row>
            <Col xs={12}>
              <div className="devops_works_box">
                <div className="num_box">01</div>
                <h5>Smooth Communication & Collaboration</h5>
                <p>
                  Our DevOps enablement is directed towards enhancing
                  communication between developers, and operations, aligning
                  them for greater efficiency, and performance.
                </p>
              </div>
              <div className="devops_works_box">
                <div className="num_box">02</div>
                <h5>Logging & Monitoring</h5>
                <p>
                  Gather, classify, and analyze big data from applications, and
                  infrastructure to track performance, and give feedback to make
                  key adjustment to services.
                </p>
              </div>
              <div className="devops_works_box">
                <div className="num_box">03</div>
                <h5>Continuous Delivery</h5>
                <p>
                  Utilizing automated testing to ensure that all code is
                  swiftly, and safely delivered, and deployed to the production
                  setup.
                </p>
              </div>
              <div className="devops_works_box">
                <div className="num_box">04</div>
                <h5>Continuous Integration</h5>
                <p>
                  Leveraging test automation to ensure that even the smallest
                  update runs smoothly while maintaining the software functional
                  at all times.
                </p>
              </div>
              <div className="devops_works_box">
                <div className="num_box">05</div>
                <h5>IaC & Seamless Development</h5>
                <p>
                  Our framework fosters embracing a modern-service architecture
                  by leveraging serverless components and connecting with the
                  infrastructure.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Devopsworks;
